import { get } from 'lodash';
import React from 'react';
import { OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import WarningIcon from 'src/components/Icon/Warning';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { ResponsiveAnimation } from 'src/components/Modules/Components';
import ModuleStyle from 'src/components/Modules/Components/ModuleStyle';
import { moduleStyleProps } from 'src/components/Modules/Components/ModuleStyle/tools';
import Switcher from 'src/components/SectionSwitcher';
import AutoPlay from 'src/constrains/SalesChannelPreviewPageComponents/AutoPlay';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  EModuleWidth,
  ENewTabLayerType,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveResizingOption,
} from 'src/types/common/module';
import css from './css.module.less';
const Option = OriSelect.Option;
const ResponsiveContentCarousel = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //console.log(props);
  const {
    images,
    onItemAdd,
    onItemDelete,
    onItemSort,
    onStaticChange,
    onOpenNewTab,
    specificError,
    staticData,
    animations,
    hoverAnimations,
    isConvertible,
  } = props;
  //console.log('isConvertible', isConvertible);

  //console.log('specificError', specificError);
  const { layers } = specificError;
  const layersHasError = !!Object.values(layers).find((i) => i);
  //const imageLayerError=
  const draggableId = get(staticData, 'draggableId');
  const animation = get(staticData, 'animation');
  const autoPlay = get(staticData, 'autoPlay');
  const intervalTime = get(staticData, 'intervalTime');
  const moduleStyle = get(staticData, 'moduleStyle');
  const moduleWidth = get(staticData, 'moduleWidth');
  const resizingOption = get(staticData, 'resizingOption');
  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnAutoPlayChange = (autoPlay) => {
    onStaticChange({ autoPlay });
  };

  const handleOnIntervalChange = (intervalTime) => {
    onStaticChange({ intervalTime });
  };

  const handleOnResizingOptionChange = (resizingOption) => {
    onStaticChange({ resizingOption });
  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  const handleOnItemAdd = () => {
    if (onItemAdd) {
      //const item = generateResponsiveImage();
      //console.log('item', item);
      onItemAdd();
    }
  };

  const handleOnEdit = (id, data, displayError) => {
    const _data = { ...data };
    // if (displayError) {
    //   _data.isNew = false;
    // }

    onOpenNewTab({
      imageId: id,
      data: _data,
      contentListId: draggableId,
      type: ENewTabLayerType.Image,
    });
  };

  const handleItemOnSort = (from, to) => {
    if (onItemSort) {
      onItemSort(from, to);
    }
  };

  const handleOnItemDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  return (
    <React.Fragment>
      <Section size='small' bottomBorder className={css.container}>
        <ItemWrapper title={getI18n('general.moduleWidth')}>
          <OriSelect
            size='large'
            value={moduleWidth}
            onChange={handleOnModuleWidthChange}>
            <Option value={EModuleWidth.FULL}>
              {getI18n('general.fullWidth')}
            </Option>
            <Option value={EModuleWidth.WIDE}>
              {getI18n('general.wideWidth')}
            </Option>
            {isConvertible ? null : (
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            )}
          </OriSelect>
        </ItemWrapper>
        {!isConvertible && (
          <div className={css.autoContainer}>
            <AutoPlay
              isAuto={autoPlay}
              interval={intervalTime}
              interOnChange={handleOnIntervalChange}
              autoOnChange={handleOnAutoPlayChange}
            />
          </div>
        )}
      </Section>
      <Section size='small' bottomBorder>
        <ItemWrapper title={getI18n('general.responsiveResizingOption')}>
          <OriSelect
            size='large'
            value={resizingOption}
            onChange={handleOnResizingOptionChange}>
            <Option value={EResponsiveResizingOption.SCALABLE}>
              {getI18n('general.scaleHeightBasedOnModuleWidth')}
            </Option>
            <Option value={EResponsiveResizingOption.FIXED}>
              {getI18n('general.fixedHeight')}
            </Option>
          </OriSelect>
        </ItemWrapper>
      </Section>
      <Section size='small' className={css.switcherContainer}>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ModuleStyle
                    {...moduleStyleProps(moduleWidth)}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                    isMobileOrTablet={isConvertible}
                  />
                </div>
              ),
            },
            ...(isConvertible
              ? {}
              : {
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                }),
            [EResponsiveCarouselModuleSwitcherType.Image]: {
              title: getI18n('general.checkImgDraggableDisplay.title'),
              hasError: layersHasError,
              child: (
                <Images
                  error={layers || {}}
                  data={images}
                  onSort={handleItemOnSort}
                  onDelete={handleOnItemDelete}
                  onDuplicate={() => {
                    console.log('duplicate');
                  }}
                  onEdit={handleOnEdit}
                  onAdd={handleOnItemAdd}
                  draggableId={draggableId}
                  isConvertible={isConvertible}
                />
              ),
            },
          }}
        />
      </Section>
    </React.Fragment>
  );
};
export default ResponsiveContentCarousel;

// const Animation = (props) => {
//   const { data, onChange, animations } = props;
//   const _animations = [
//     { value: null, label: 'None' },
//     ...(animations || []).map((i) => {
//       const { name, uuid } = i;
//       return { label: name, value: uuid };
//     }),
//   ];
//   const entranceUuid = get(data, 'entranceUuid') || null;
//   const hoverEffectUuid = get(data, 'hoverEffectUuid') || null;
//   return (
//     <React.Fragment>
//       <ItemWrapper size='small' title='Entrance Animation'>
//         <OriSelect
//           size='large'
//           value={entranceUuid}
//           onChange={(entranceUuid) => {
//             onChange({ entranceUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//       <ItemWrapper size='small' title='Hover Effect'>
//         <OriSelect
//           size='large'
//           value={hoverEffectUuid}
//           onChange={(hoverEffectUuid) => {
//             onChange({ hoverEffectUuid });
//           }}>
//           {_animations.map((i) => {
//             const { label, value } = i;
//             return (
//               <Option value={value} key={value || 'None'}>
//                 {label}
//               </Option>
//             );
//           })}
//         </OriSelect>
//       </ItemWrapper>
//     </React.Fragment>
//   );
// };
const Images = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    data,
    onSort,
    onDelete, // onDuplicate,
    onEdit,
    onAdd,
    draggableId,
    error,
    isConvertible,
  } = props;

  const handleOnChildGenerate = (data, index) => {
    const { name, draggableId } = data;
    // console.log('data1', data);
    const hasError = error[draggableId];
    return (
      <TextAndEditIcon
        additional={
          hasError ? (
            <div className={css.errorIconContainer}>
              <WarningIcon />
            </div>
          ) : null
        }
        name={name}
        onClick={() => {
          if (onEdit) onEdit(draggableId, data, hasError);
        }}
      />
    );
  };
  const handleOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onSort(oldIndex, newIndex);
  };
  return (
    <DragNDropColumns
      disabled={isConvertible}
      // hideAdd={!isPrimary}
      hideTitle
      childGenerate={handleOnChildGenerate}
      data={data}
      droppableId={`salesChannelContentListResponsiveImageCarousel${draggableId}`}
      onSort={handleOnSort}
      // hideAdd={hideAdd}
      onAdd={onAdd}
      addText={`+ ${getI18n('general.addImage')}`}
      onDelete={isConvertible ? null : onDelete}
    />
  );
};
